import MultipleDashboard from './MultipleDashboards'

export default MultipleDashboard